import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { setTestDrivePointAction } from "@redux/actions/testDriveActions";

export const useTestDrivePointHandler = target => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (target) {
      dispatch(setTestDrivePointAction(target));
    }
  }, [target.language]);
};
